<script setup lang="ts">
import { useElementVisibility, whenever } from '@vueuse/core';
import { ComponentPublicInstance, onMounted, ref, watch } from 'vue';
import { RouteLocationNormalized } from 'vue-router';

import CmsContent from '@/components/cms/CmsContent.vue';
import { useCms } from '@/composables/useCms';
import { useReferralElement } from '@/composables/useReferralElement';
import { useCustomer } from '@/stores/customer';

const referralPage = ref<ComponentPublicInstance>();
const visible = useElementVisibility(referralPage);
const { content: cmsContent } = useCms('referral-page', {
  contentVisible: () => visible.value,
  prefetch: 'setup',
});

const registerReferralCreatives = () => {
  const b2bCta = document.querySelector<HTMLElement>('#b2b-cta');
  const dtcCta = document.querySelector<HTMLElement>('#dtc-cta');

  useReferralElement(b2bCta, 'landing_page_cta', 'refer-a-business');
  useReferralElement(dtcCta, 'landing_page_cta');
};

onMounted(async () => {
  watch(() => useCustomer().customer, registerReferralCreatives);
  whenever(() => cmsContent.value.result, registerReferralCreatives, { immediate: true });
});

defineOptions({
  async criticalData(_: any, to: RouteLocationNormalized) {
    if (typeof window === 'undefined') {
      await useCms('referral-page', { prefetch: 'criticalData' }).loadCmsContent(to.path, to.query);
    }
  },
});
</script>

<template>
  <CmsContent :content="cmsContent" model="referral-page" ref="referralPage" />
</template>
